export const checkIfUnitHasPendingBasicSupply = (unitId, pendingSupply) => {
  return pendingSupply.some(s => s.unitId === unitId && !s.additionalSupply);
}
